import { Navigate } from "react-router-dom";
import { useLoginUser } from "../context/loginUser";

const isLoggedIn = (user, token) =>
  typeof token === "string" &&
  token?.length > 0 &&
  user !== "" &&
  user != null;

// AuthGuard component to protect routes based on user authentication
export const AuthGuard = ({ children }) => {
  const { user, token } = useLoginUser();

  if (!isLoggedIn(user, token)) {
    return <Navigate to="/getstarted" replace />;
  }

  return <>{children}</>;
};
